import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

/**
 * Hook to get the current user's org_id
 * Required for storage uploads that need org-based folder paths
 */
export const useOrgId = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['user-org-id', user?.id],
    queryFn: async () => {
      if (!user) return null;
      
      const { data, error } = await supabase
        .from('profiles')
        .select('org_id')
        .eq('id', user.id)
        .single();
      
      if (error) throw error;
      return data?.org_id as string | null;
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};
